// A record page (the call page) can dock Nova beside the record instead of
// letting the panel drop over it (docs/COPILOT.md, "Record pages").
// The page registers the element Nova renders into; CopilotBar owns the open
// state and tells the page when it changes. The page asks to open or close
// through requestNovaOpen. No dock registered: the dropdown, as everywhere else.

export interface NovaDock {
  element: HTMLElement;
  onOpenChange: (open: boolean) => void;
}

let dock: NovaDock | null = null;
let openRequest: ((open: boolean) => void) | null = null;
const listeners = new Set<() => void>();

export function getNovaDock(): NovaDock | null {
  return dock;
}

export function registerNovaDock(next: NovaDock): () => void {
  dock = next;
  listeners.forEach((listener) => listener());
  return () => {
    if (dock !== next) return;
    dock = null;
    listeners.forEach((listener) => listener());
  };
}

export function subscribeNovaDock(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function setNovaOpenRequestHandler(handler: (open: boolean) => void): () => void {
  openRequest = handler;
  return () => {
    if (openRequest === handler) openRequest = null;
  };
}

export function requestNovaOpen(open: boolean) {
  openRequest?.(open);
}
